<template>
    <div class="container">
        <p>
            Mes coordonnées <br />
            E-mail : {{ coord.mail }} <br />
            Ville : {{ coord.ville }}, {{ coord.departement }}, {{ coord.pays }} <br />
            Langues : {{ coord.langue }} <br />
	    Score ROOT-ME : {{ coord.score_root_me }}
        </p>
        <a :href="coord.linkedin">
            <img class="icone_lk" :src="getImg(coord.linkedin_img)" alt="icone"/>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'Coordonnees',
        props: ['coord'],
	methods: {
            getImg(img) {
                 return require('../../public/img/' + img);
            }
        }
    };
</script>

<style>
    a:focus {
        outline: none;
    }
    .icone_lk {
        width: 50px;
        height: 50px;
        display: inline-block;
    }
    p {
	font-weight: bold;
    }

</style>
